var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopyWhite = function SvgCopyWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#FC2B82",
    rx: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeWidth: 1.5,
    clipPath: "url(#copy-white_svg__a)",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.667 1.333H8c-1.886 0-2.828 0-3.414.63C4 2.596 4 3.61 4 5.642v.718c0 2.03 0 3.046.586 3.677.586.63 1.528.63 3.414.63h2.667c1.885 0 2.828 0 3.414-.63.586-.631.586-1.647.586-3.677V5.64c0-2.031 0-3.046-.586-3.677s-1.529-.631-3.414-.631Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.999 11.072c-.008 1.564-.073 2.41-.585 2.963-.586.631-1.529.631-3.415.631H5.332c-1.885 0-2.828 0-3.414-.631-.586-.632-.586-1.649-.586-3.682v-.719c0-2.033 0-3.05.586-3.682.427-.46 1.045-.585 2.081-.619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "copy-white_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgCopyWhite;